import { render, staticRenderFns } from "./ExpiryDates.vue?vue&type=template&id=4444d139&"
import script from "./ExpiryDates.vue?vue&type=script&lang=js&"
export * from "./ExpiryDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports